module.exports = "/_next/static/images/09-1eafedcbaec2bb44e76922e3aaea536a.png";